import isString from 'lodash/isString.js';

export default function stripWhitespace(string = '') {
  if (!isString(string)) {
    return string;
  }
  return string.replace(/\s/g, '');
}
